export const LANGUAGE = "Accept-Language";
export const AUTH = "Authorization";
export const SKIP_AUTH = "X-Skip-Authorization";
export const ENGLISH = "en";
export const UNAUTORIZED_STRING = 'UNAUTHORIZED_ERROR';